var a=a=>!!a?.[Symbol.iterator];export{a as default};